<template>
  <div>
    <div class="row mb-md-2" >
      <div class="col-sm-12 col-md-6" v-if="noPerPage">
        <div class="dataTables_length">
          <label class="d-inline-flex align-items-center dataTable_entries">
            <span >{{ $t('common.show') }}</span>
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
            <span >{{ $t('common.entries') }}</span>
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div
          id="tickets-table_filter"
          class="dataTables_filter"
          :class="!noPerPage ? '' : 'text-md-right'"
        >
          <label class="d-inline-flex align-items-center dataTable_search">
            <span >{{ $t('common.search') }}:</span>
            <b-form-input
              v-model="searchText"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ml-2"
              @input="onSearchInput"
            ></b-form-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>
    <!-- Table -->
    <div class="table-responsive mb-0">
      <b-table
        :busy="isBusy"
        :items="items"
        :fields="fields"
        responsive="lg"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        details-td-class="align-test"
      >

        <template 
          v-slot:cell(actions)="row" 
          v-if="user.role.role == 'administration' || user.recruitment_type == 'company'"
        >
          <div class="d-flex justify-content-end">
            <b-dropdown class="" variant="none" size="sm mx-1 mb-1" right>
              <template slot="button-content">
                <button class="btn2 btn2-primary btn-sm p-2 px-3">
                  Action
                  <i class="uil uil-angle-down"></i>
                </button>
              </template>

              <!-- <b-dropdown-item
                v-if="useAs == 'administration'"
                variant="success"
                :to="{ path:'/administration/user/view', query:{id:row.item._id} }"
              > -->
              <b-dropdown-item
                class="btn2-tertiary"
                v-if="useAs == 'administration'"
                @click="onClickLink(row.item, 'viewUser')"
              >
                <i class="uil-eye"></i> View
              </b-dropdown-item>

              <!-- <b-dropdown-item
                v-if="useAs == 'administration'"
                variant="success"
                :to="'/administration/user/edit?id=' + row.item._id"
              > -->
              <b-dropdown-item
                class="btn2-tertiary"
                v-if="useAs == 'administration'"
                @click="onClickLink(row.item, 'editUser')"
              >
                <i class="uil-edit"></i> Edit
              </b-dropdown-item>

              <b-dropdown-item
                class="btn2-tertiary"
                @click="onActivate(row.item)"
              >
                <i class="uil"
                  :class="row.item.active ? 'uil-times-circle' : 'uil-check'" 
                ></i>
                {{ row.item.active ? 'Deactivate' : 'Activate' }}
              </b-dropdown-item>
              <b-dropdown-item
                class="btn2-tertiary"
                @click="onClickLink(row.item, 'userChangePassword')"
              >
                <i class="uil-lock"></i> Change Password
              </b-dropdown-item>
            </b-dropdown>
          </div>

        </template>

        <template v-slot:cell(access_type)="row" v-if="useAs == 'administration'">
          <div>{{ getAccessType(row.item) }}</div>
          <div
            class="font-weight-bold"
            v-if="row.item.parent_id && row.item.parent_id.company_name"
          >
            Company: {{ row.item.parent_id.company_name }}
            <span
              class="badge badge-pill badge-danger"
              v-if="row.item.parent_id && row.item.parent_id.company_name && !row.item.parent_id.active"
            >
              Company is Deactivated
            </span>
          </div>
        </template>

        <template v-slot:cell(full_name)="row">
          <span class="font-weight-600">{{ displayUserName(row.item) }}</span>
          <div>{{ row.item.email }}</div>
          <span
            v-if="useAs == 'administration'"
            @click="onClickLink(row.item, 'viewUser')"
            class="text-primary d-inline-block mt-1"
            style="cursor: pointer;"
          >
            View profile
          </span>
        </template>

        <template v-slot:cell(status)="row">
          <h4>     
            <span
              :class="'badge badge-pill badge-' + (row.item.pending ? 'secondary' : (row.item.active ? 'success' : 'danger' ))">
              {{ row.item.pending ? "Pending Invitation" : (row.item.active ? "Active" : "Inactive" ) }}
            </span>
          </h4>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div
          class="dataTables_paginate paging_simple_numbers float-right"
        >
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- actions -->
    <Dialog
      is_reset_model
      ref="userChangePassword"
      :parameters="{ rowId }"
      :component="changePassComponent"
      :buttonDisable="passwordChanged"
      size="md"
      centered
      title="Change Password"
      headerClass="border-none"
      yesText="Submit"
      noText="Cancel"
      @onYes="onChangePassword"
    />
    <Dialog
      :parameters="{ rowId, submitted }"
      :component="viewComponent"
      :titleHtml="`<p class='h5 m-0'>${$t('user.plural')}</p>`"
      size="lg"
      centered
      ref="viewUser"
      bodyClass="modalBodyContainer px-0"
      headerClass="border-none"
      @onClick="onClickViewActions"
    />
    <Dialog
      customBtnClass="component-user-edit" 
      autoload
      centered
      yesText="Edit"
      noText="Cancel"
      title="Edit Information"
      ref="editUser"
      size="xl"
      :parameters="{ rowId, type: 'users' }"
      :component="computedEditComponent"
      @onYes="onEditUser"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import FormMixin from '@mixins/form'
import Dialog from '@components/offcanvas'
import ViewUser from '../components/dialogs/view.vue'
import ChangePasswordComponent from '../components/dialogs/change_password.vue'
import error from '@utils/error'

export default {
  components:{
    Dialog
  },
  mixins: [ FormMixin ],
  props: {
    noPerPage:{
      default:true
    },
    param:{
      type: Object,
      default: function () {
        return {  }
      }
    },
    initialLoad:{
      default:true
    },
    useAs:{
      default:'administration'
    }
  },
	data() {
    let columns = []

    if(this.useAs == 'administration'){
      columns = [
				{ key: 'full_name', label:this.$t('user.table.full_name'), sortable: true,  tdClass: 'align-middle', },
        { 
          key: 'access_type', 
          label:this.$t('user.table.access_type'),
          formatter: (value, key, item) => {
            let additional = ''
            if(item.recruitment_type){
              additional = item.recruitment_type.toString().replace(/^\w/, c => c.toUpperCase())
            }
            return item.role ? item.role.name.toString().replace(/^\w/, c => c.toUpperCase()) + (additional ? ' / ' + additional : '') : ''
          },
          tdClass: 'align-middle',
        },
        { key: 'status', 
          label:this.$t('user.table.status'),
          tdClass: 'align-middle',
        },
        {
          key: 'last_login',
          label: 'Last Login',
          sortable: true,
          formatter: (value) => {
            return value ? moment(value).format('YYYY-MM-DD hh:mm A') : '-'
          },
          tdClass: 'align-middle',
        },
        {
          key: 'date_created',
          label:this.$t('user.table.date_created'),
          sortable: true,
          formatter: (value) => {
            return moment(value).format('YYYY-MM-DD')
          },
          tdClass: 'align-middle',
        },
        {
          key:'actions',
          label:'',
          tdClass: 'align-middle',
        }
      ]
    }

    if(this.useAs != 'administration'){
      columns = [
				{ key: 'full_name', label:this.$t('user.table.full_name'), sortable: true },
        { key: 'status', 
          label:this.$t('user.table.status')
        },
        {
          key:'actions',
          label:''
        }
      ]
    }

		return {
			items: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortBy: '',
			sortDesc: false,
			fields: columns,
      isBusy:false,
      type:'all',
      submitted: false,
      active:false,
      passwordChanged:false,
      updatedUser:false,
      selectedUser:{},
      change_pass:{
        old_password:'',
        new_password:'',
        confirm_password:'',
      },
      searchText: '',
      searchDebounce: null,
      selectedAccessTypes: [],
      rowId: ''
		}
	},
	computed: {
		rows() {
			return this.totalRows
		},
    viewComponent () {
      return ViewUser
    },
    computedEditComponent() {
      return () => import('../components/dialogs/edit.vue')
    },
    changePassComponent () {
      return ChangePasswordComponent
    }
	},
	methods: {
		...mapActions('user', ['pagination', 'activate', 'changePassword', 'update']),
    onEditUser(val) {
      if(this.role_modules.some(item => item.value == 'user')){
        this.updatedUser = true;
        let model = val && val.model && Object.entries(val.model).length ? val.model : val

        val.validateForm && val.validateForm()
        if (val.$v && val.$v.$error) {
          this.updatedUser = false;
          return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
        }

        var formData = new FormData();
        if(model.files){
          model.files.forEach((file) => {
            formData.append("files", file);
          });
        }
        if(model.function_id && model.function_id.length) {
          model.function_id.forEach((res) => {
            formData.append("function_id", res._id);
          });
        }
        if(model.industry_id && model.industry_id.length) {
          model.industry_id.forEach((res) => {
            formData.append("industry_id", res._id);
          });
        }
        if(model.brand_id && model.brand_id.length) {
          model.brand_id.forEach((res) => {
            formData.append("brand_id", res._id);
          });
        }
        formData.append("id", this.rowId);
        formData.append("first_name", model.first_name);
        formData.append("last_name", model.last_name);
        formData.append("access_type_id", model.access_type._id);
        formData.append("access_type", model.access_type.role);
        formData.append("recruitment_type", model.recruitment_type);
        formData.append("website", model.website);
        formData.append("contact_no", model.contact_no);
        formData.append("company_name", model.company_name);
        formData.append("city", model.city);
        formData.append("country", model.country);
        formData.append("city", model.city);
        formData.append("company_details", model.company_details);
        formData.append("rate", model.rate);
        formData.append("fixed", model.fixed);
        formData.append("contact_person", model.contact_person);
        formData.append("contract_start_date", model.contract_start_date);
        formData.append("contract_end_date", model.contract_end_date);

        if(model.removed) {
          model.removed.forEach((id) => {
            formData.append("removed_ids", id);
          });
        }

        this.update(formData)
        .then(result => {
          if (result && result.data) {
            this.$refs.editUser.hide();
            this.fetchData(this.type, this.active);
            this.submitted = !this.submitted;
            this.$bvToast.toast(`User information is successfully updated`, {
              title: "Notification",
              variant: "success"
            })
            setTimeout(() => {
              this.updatedUser = false;
            }, 1500)
          }
        })
        .catch(err => {
          this.updatedUser = false;
          return error.errorHandler(err, this.$bvToast)
        })
      }
    },
    onChangePassword(val) {
      this.passwordChanged = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = this.rowId

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.passwordChanged = false
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      this.changePassword(model)
      .then(result => {
        if (result && result.data && result.data.success) {
          this.$refs.userChangePassword.hide();
          this.$bvToast.toast("Password successfully changed!", {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.passwordChanged = false;
          }, 1500)
        }
        else {
          this.passwordChanged = false;
          return error.errorHandler(result, this.$bvToast)
          // this.$bvToast.toast(`${result.data.errorMessage}`, {
          //   title: "Notification",
          //   variant: "danger"
          // })
        }
      })
      .catch(err => {
        this.passwordChanged = false;
        return error.errorHandler(err, this.$bvToast)
      })
    },
    onClickViewActions(val) {
      if (typeof val == 'object' && val.type && val.model && val.type) {
        if (val.type.toLowerCase() == 'function') this[val.ref](val.model)
        else {
          this.rowId = val.model.id
          this.$refs[val.ref].show()
        }
      }
    },
    onClickLink(val, refParam) {
      this.rowId = typeof val == 'object' && val._id ? val._id : val
      this.$refs[`${refParam}`].show()
    },
    displayUserName(item = {}) {
      const first = String(item.first_name || '').trim()
      const last = String(item.last_name || '').trim()
      const fullName = `${first} ${last}`.trim()
      if (fullName) return fullName
      if (item.company_name) return item.company_name
      if (item.full_name && item.full_name !== 'undefined undefined') return item.full_name
      return 'No name provided'
    },
    onSearchInput() {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce)
      }
      this.searchDebounce = setTimeout(() => {
        this.currentPage = 1
        this.fetchData(this.type, this.active)
      }, 350)
    },
    async fetchData(type, _atv, access_type) {
      let params = {}
      this.type = type
      this.active = _atv
      if (access_type !== undefined) {
        this.selectedAccessTypes = Array.isArray(access_type) ? access_type : [access_type]
      }
      this.isBusy = true

      params = {
        ...this.param,
        length: this.perPage,
        start: (Math.max(this.currentPage, 1) - 1) * this.perPage,
        access_type: this.selectedAccessTypes,
        filter: this.searchText,
        sort_by: this.sortBy || 'date_created',
        sort_desc: this.sortDesc,
        type:type,
        _atv:_atv
      }

      await this.pagination(params)
        .then(res => {
          this.totalRows = parseInt(res.data.total, 10)
          this.items = res.data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    getAccessType(item){
      var additional = ''
      var value = item.role
      if(item.recruitment_type){
        additional = item.recruitment_type.toString().replace(/^\w/, c => c.toUpperCase())
      }
      return value ? value.name.toString().replace(/^\w/, c => c.toUpperCase()) + (additional !== 'Null' && additional ? ' / ' + additional : '') : ''
    },
    onActivate (item) {
      let model = item && item.model && Object.entries(item.model) ? item.model : item

      this.$bvModal.msgBoxConfirm('Are you sure you want to ' + (model.active ? 'Deactivate' : 'Activate'), {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.activate({
            _id: model._id,
            active:model.active
          }).then(res => {
            this.submitted = !this.submitted
            this.fetchData(this.type, this.active)
            this.$bvToast.toast(`User ${model.full_name} has been ${res.data.active ? 'Activated' : 'Deactivated'}!`, {
              title: 'Notification',
              variant:'success'
            })
          })
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
  },
  mounted(){
    if(this.initialLoad){
      this.fetchData(this.type, this.active)
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData(this.type, this.active).catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData(this.type, this.active).catch(error => {
          console.error(error)
        })
      }
    },
    sortBy: {
      handler: function() {
        this.fetchData(this.type, this.active).catch(error => {
          console.error(error)
        })
      }
    },
    sortDesc: {
      handler: function() {
        this.fetchData(this.type, this.active).catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<style lang="scss">
  .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }
</style>